import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

export default function DragHandle({ dragHandleProps, disabled = false, label = 'Drag to reorder' }) {
    return (
        <Tooltip title={label}>
            <span>
                <IconButton
                    size="small"
                    {...dragHandleProps}
                    disabled={disabled}
                    aria-label={label}
                    sx={{ cursor: disabled ? 'not-allowed' : 'grab' }}
                >
                    <DragIndicatorIcon fontSize="small" />
                </IconButton>
            </span>
        </Tooltip>
    );
}
